function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
const gltfUrl = getParameterByName('gltf');
const usdzUrl = getParameterByName('usdz');
const arScale = getParameterByName('arScale') === '1';
const arAnchor = getParameterByName('arAnchor') || 'floor';
const modelViewer = document.querySelector('model-viewer');
if (modelViewer) {
    if (!arScale)
        modelViewer.setAttribute('ar-scale', 'fixed');
    if (arAnchor)
        modelViewer.setAttribute('ar-placement', arAnchor);
    if (usdzUrl)
        modelViewer.setAttribute('ios-src', usdzUrl);
    if (gltfUrl)
        modelViewer.setAttribute('src', gltfUrl);
}
